var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 69,
  height: 4,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 2,
  r: 1.5,
  fill: "#D9D9D9"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 2,
  r: 1.5,
  fill: "#D9D9D9"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 2,
  r: 1.5,
  fill: "#D9D9D9"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.5,
  cy: 2,
  r: 1.5,
  fill: "#D9D9D9"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 45.5,
  cy: 2,
  r: 1.5,
  fill: "#D9D9D9"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.5,
  cy: 2,
  r: 1.5,
  fill: "#D9D9D9"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 67.5,
  cy: 2,
  r: 1.5,
  fill: "#D9D9D9"
})));
export { SvgDot as ReactComponent };
export default __webpack_public_path__ + "static/media/Dot.96ed05fa.svg";